var App = App || {};

App.WhyIvesBand = (function ($) {
    "use strict";

    function init() {

        const whyIvesBands = $(".block.block-why-ives");
        if (whyIvesBands.length) {
            whyIvesBands.each(function () {
                InitCarousels($(this));
            });
        }
    }

    function InitCarousels(whyIvesBand) {
        const carousel = whyIvesBand.find(".why-cards-mobile.splide");
        if (carousel.length) {
            const splideCarousel = new Splide(carousel[0], {
                pagination: true,
                type: 'loop',
                fixedWidth: "23rem",
                gap: "16px",
                drag: true,
                snap: false,
                perMove: 1
            });

            splideCarousel.mount();
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.WhyIvesBand.init();
});